import { Paper, Typography, Box, Divider } from '@mui/material';
import { Email, Phone } from '@mui/icons-material';
import CopyButton from './CopyButton';

const NotFound = () => (
	<span>N/A</span>
);

const ContactCard = ({ contact }) => {
	if (!contact) return <NotFound />;
	
	const { contact_id, contact_type, name, first_name, last_name, title, phone, phonetext, email } =
		contact;

	if (!first_name && !last_name && !name) return <NotFound />;

	const getFullName = () => `${first_name || ''} ${last_name || ''}`;
	const getCopyText = () => `${name ? name : getFullName()}\n${phonetext || phone || ''}\n${email || ''}`;

	return (
		<Paper
			sx={{
				display: "flex",
				flexDirection: "column",
				gap: 1,
				padding: '1em',
				minWidth: '250px',
				fontSize: '0.75em',
				position: 'relative'
			}}
		>
			<CopyButton
				copyText={getCopyText()}
				sx={{
					position: 'absolute',
					right: '.25em',
					top: '.25em'
				}}
			/>

			<Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
				<Box>
					<Typography variant="h6" sx={{ lineHeight: 1 }}>
						{name || getFullName()}
					</Typography>
					<Typography variant="subtitle2" color="text.secondary">
						{title}
					</Typography>
				</Box>
			</Box>
			
			<Typography
				variant="body2"
				color="text.secondary"
				sx={{ display: "flex", alignItems: "center" }}
			>
				<Phone fontSize="small" sx={{ mr: 1 }} /> { phonetext || phone || <NotFound /> }
			</Typography>
			
			
			<Typography
				variant="body2"
				color="text.secondary"
				sx={{ display: "flex", alignItems: "center" }}
			>
				<Email fontSize="small" sx={{ mr: 1 }} /> { email || <NotFound /> }
			</Typography>

			<Divider variant="middle" />
			
			<Typography
				variant="body2"
				color="text.secondary"
				sx={{ display: "flex", alignItems: "space-between" }}
			>
				ID:&nbsp;{ contact_id || <NotFound /> },
				Contact Type:&nbsp;{ contact_type || <NotFound /> }
			</Typography>
		</Paper>
	);
}

export default ContactCard;
